import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { listBanners } from '../../api/banner';

const BannerArea = () => {

    const [banners, setBanners] = useState([]);

    useEffect(function() {
        listBanners().then(function(result) {
            setBanners(result);
        });
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: true,
      };

    return (
        <>{banners.length > 0 &&
        <div>
        <Slider {...settings}>
        {banners.map((banner, index) => (
          <div key={index}>
            <img style={{width: "100%"}} src={"https://v1.profaprizattera.com.br/uploads/banner/" + banner.file} alt={banner.file} />
          </div>
        ))}
        </Slider>
      </div>}
        </>
        );

}

export default BannerArea;